import { render, staticRenderFns } from "./ui-breadcrumb.vue?vue&type=template&id=62be3dfb&scoped=true"
import script from "./ui-breadcrumb.vue?vue&type=script&lang=js"
export * from "./ui-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./ui-breadcrumb.vue?vue&type=style&index=0&id=62be3dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be3dfb",
  null
  
)

export default component.exports